import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';


interface ArticleViewModalProps {
  article: {
    id?: string;
    title: string;
    author: string;
    content: string;
    thumbnailUrl?: string;
  } | null;
  isOpen: boolean;
  onClose: () => void;
}

export default function ArticleViewModal({ article, isOpen, onClose }: ArticleViewModalProps) {
  if (!article) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">
            {article.title}
          </DialogTitle>
        </DialogHeader>
        
        <div className="overflow-y-auto flex-1 pr-2">
          <div className="mb-4 pb-4 border-b border-slate-200">
            <p className="text-sm text-slate-600">
              By <span className="font-medium">{article.author}</span>
            </p>
          </div>
          
          {article.thumbnailUrl && (
            <div className="mb-6">
              <img 
                src={article.thumbnailUrl} 
                alt={article.title}
                className="w-full max-w-md h-auto rounded-lg"
              />
            </div>
          )}
          
          <div 
            className="prose prose-slate max-w-none"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}